require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-team-marco-vermaasen.json") })
        }
      }, "path---en-us-team-marco-vermaasen");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-team-marco-vermaasen!./.cache/json/en-us-team-marco-vermaasen.json
// module id = 595
// module chunks = 231608221292675